import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../hooks/auth.hook";

function PrivateRoute({ children, ...rest }) {
    let auth = useAuth();
    return (
        <>
            <Route {...rest} render={({location}) =>
            auth.user.logged === true ? (
                children
              ) : auth.user.logged === false ? (
                <Redirect
                  to={{
                    pathname: "/login",
                    state: { from: location },
                  }}
                />) :(
                    auth.user.logged === null && (
                      <Redirect
                        to={{
                          pathname: "/loading",
                          state: { from: location },
                        }}
                      />
                    )
                )}>
            </Route>
        </>
    )
  }

export default PrivateRoute;